export const AUTOCOMPLETE_REQUEST_SUPERSEDED = 'Autocomplete request superseded';
export const ASYNC_RESOURCE_DISPOSED = 'Async resource disposed';
export const ASYNC_RESOURCE_LOAD_SUPERSEDED = 'Async resource load superseded';

export function createAbortError(reason: string): DOMException {
  return new DOMException(reason, 'AbortError');
}

export function isAbortError(cause: unknown): boolean {
  return cause instanceof Error && cause.name === 'AbortError';
}
